// Author Liu Cui Cui
// Date 2023-08-14 14:20:13

import * as model from "@/model/sithMes/tpm/SithMesTpmSpindleDataTsdModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";
import {customVuexFilterPatternFactory} from "@/store/em/commonPattern/customVuexFilterPatternFactory";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesTpmSpindleDataTsd(), newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_TPM_URL,
    })
    .withPatternFactory(customVuexFilterPatternFactory, {
        filterState: 'spindleDataImageFilter',
        filterInitializer: newFilter
    })
    .buildStore()
